import { createContext } from 'react';
import { AccountsOrdersParam } from '../type';

export const accountsOrdersParamsContext = createContext<Partial<AccountsOrdersParam>>({});
